(() => {
  if (customElements.get('facet-filters-form')) {
    return;
  }

  class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
      this.querySelector('form').addEventListener(
        'input',
        this.debouncedOnSubmit.bind(this),
      );

      this.onClickFilterTrigger();
    }

    static setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state
          ? event.state.searchParams
          : FacetFiltersForm.searchParamsInitial;
        if (searchParams === FacetFiltersForm.searchParamsPrev) return;
        FacetFiltersForm.renderPage(searchParams, null, false);
      };
      window.addEventListener('popstate', onHistoryChange);
    }

    static renderPage(searchParams, event, updateURLHash = true) {
      FacetFiltersForm.searchParamsPrev = searchParams;
      const sections = FacetFiltersForm.getSections();

      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
          : FacetFiltersForm.renderSectionFromFetch(url, event);

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
      });
    }

    static renderSectionFromFetch(url, event) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          FacetFiltersForm.filterData = [
            ...FacetFiltersForm.filterData,
            { html, url },
          ];
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
        });
    }

    static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
    }

    static renderProductGridContainer(html) {
      const collectionComponent = document.querySelector(
        'collection-component',
      );
      if (collectionComponent) {
        return;
      }

      document.getElementById('ProductGridContainer').innerHTML =
        new DOMParser()
          .parseFromString(html, 'text/html')
          .getElementById('ProductGridContainer')?.innerHTML;
    }

    static renderProductCount(html) {
      const collectionComponent = document.querySelector(
        'collection-component',
      );
      if (collectionComponent) {
        return;
      }

      const count = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('ProductCount');
      const container = document.getElementById('ProductCount');

      if (container) {
        container.innerHTML = count ? count.innerHTML : '';
      }
    }

    static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

      const facetDetailsElements = parsedHTML.querySelectorAll(
        '#FacetFiltersForm .js-filter',
      );
      const matchesIndex = (element) => {
        const jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter
          ? element.dataset.index === jsFilter.dataset.index
          : false;
      };
      const facetsToRender = Array.from(facetDetailsElements).filter(
        (element) => !matchesIndex(element),
      );
      const countsToRender =
        Array.from(facetDetailsElements).find(matchesIndex);

      facetsToRender.forEach((element) => {
        document.querySelector(
          `.js-filter[data-index="${element.dataset.index}"]`,
        ).innerHTML = element.innerHTML;
      });

      FacetFiltersForm.renderActiveFacets(parsedHTML);

      if (countsToRender)
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest('.js-filter'),
        );
    }

    static renderActiveFacets(html) {
      ['.js-facets-active', '.js-facets-remove-all'].forEach((element) => {
        const htmlElement = html.querySelector(element);
        const hostElement = document.querySelector(element);

        if (!htmlElement || !hostElement) {
          return;
        }

        hostElement.outerHTML = htmlElement.outerHTML;
      });
    }

    static renderCounts(source, target) {
      const selector = '.js-facets-selected';
      const targetElement = target.querySelector(selector);
      const sourceElement = source.querySelector(selector);

      if (sourceElement && targetElement) {
        target.querySelector(selector).outerHTML =
          source.querySelector(selector).outerHTML;
      }
    }

    static updateURLHash(searchParams) {
      const collectionComponent = document.querySelector(
        'collection-component',
      );
      if (collectionComponent) {
        collectionComponent.render('?'.concat(searchParams));
        return;
      }

      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${
          searchParams && '?'.concat(searchParams)
        }`,
      );
    }

    static getSections() {
      return [
        {
          section:
            document.querySelector('facet-filters-form').dataset.sectionId,
        },
      ];
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const context = event.target.id.includes('desktop')
        ? 'mobile'
        : 'desktop';
      const formData = new FormData();
      const formDataElements = Array.from(
        event.target.closest('form').elements,
      ).filter(
        (element) =>
          !element.id.includes(context) || element.name === 'sort_by',
      );
      for (const element of formDataElements) {
        if (!element.name) continue;
        if (element.type === 'checkbox') {
          if (element.checked) {
            formData.append(element.name, element.value);
          }
        } else {
          formData.append(element.name, element.value);
        }
      }
      const searchParams = new URLSearchParams(formData).toString();
      FacetFiltersForm.renderPage(searchParams, event);
    }

    onActiveFilterClick(event) {
      event.preventDefault();
      const url =
        event.currentTarget.href.indexOf('?') == -1
          ? ''
          : event.currentTarget.href.slice(
              event.currentTarget.href.indexOf('?') + 1,
            );
      FacetFiltersForm.renderPage(url);
    }

    onClickFilterTrigger() {
      const element = document.querySelector('[data-section-collection]');

      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes') {
            document
              .querySelector('#Details-facets-mobile')
              .hasAttribute('open')
              ? document.body.classList.add('no-scroll')
              : document.body.classList.remove('no-scroll');
          }
        });
      });

      observer.observe(element, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }
  }

  FacetFiltersForm.filterData = [];
  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  customElements.define('facet-filters-form', FacetFiltersForm);
  FacetFiltersForm.setListeners();
})();

(() => {
  if (customElements.get('price-range')) {
    return;
  }

  class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.inputs = this.querySelectorAll('input');
      this.inputs.forEach((element) =>
        element.addEventListener('change', this.onRangeChange.bind(this)),
      );

      this.setMinAndMaxValues();
    }

    onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
      const minInput = this.inputs[0];
      const maxInput = this.inputs[1];
      if (maxInput.value) minInput.setAttribute('max', maxInput.value);
      if (minInput.value) maxInput.setAttribute('min', minInput.value);
      if (minInput.value === '') maxInput.setAttribute('min', 0);
      if (maxInput.value === '')
        minInput.setAttribute('max', maxInput.getAttribute('max'));
    }

    adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute('min'));
      const max = Number(input.getAttribute('max'));

      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }

  customElements.define('price-range', PriceRange);
})();

(() => {
  if (customElements.get('facet-remove')) {
    return;
  }

  class FacetRemove extends HTMLElement {
    constructor() {
      super();
      this.querySelector('a').addEventListener('click', (event) => {
        event.preventDefault();
        const form =
          this.closest('facet-filters-form') ||
          document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    }
  }

  customElements.define('facet-remove', FacetRemove);
})();
